import { Address } from 'models';
import { AssignedAddress } from 'shared/payments';

export function toAssignableAddresses(addresses?: Address[]): AssignedAddress[] {
    return (addresses ?? []).map((address) => ({
        id: address.id,
        description: address.business_location?.name ?? address.description ?? null,
        street: address.street,
        city: address.city,
        state: address.state,
        zip_code: address.zip_code,
    }));
}
